import {PrintJob} from '../entity/print-job';

class PrintJobFactory {
    create(printerId, name, pdfProvider) {
        return new PrintJob(printerId, name, pdfProvider);
    }
}
export const printJobFactory = new PrintJobFactory();
